<label class="uv-input-label" for={{id}}>{{label}} <span *ngIf="required">*</span></label>
<div class="text-input">
    <input 
    [id]="id"
    type="text"
    [value]="value"
    (keyup)="keyupEvent($event)"
        [placeholder]="placeholder"
        class="uv-input"/>
</div>
